"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridViewDragState = exports.gridViewDragStateDefault = void 0;
const immer_1 = __importDefault(require("immer"));
const action_constants_1 = require("../../../../../shared/store/action_constants");
exports.gridViewDragStateDefault = {
    dragTarget: {},
    hoverRecordId: null,
    hoverRowOfAddRecord: null,
};
exports.gridViewDragState = (0, immer_1.default)((draft = exports.gridViewDragStateDefault, action) => {
    switch (action.type) {
        case action_constants_1.SET_DRAG_TARGET:
            draft.dragTarget = action.payload;
            return draft;
        case action_constants_1.SET_HOVER_RECORD_ID:
            draft.hoverRecordId = action.payload;
            return draft;
        case action_constants_1.SET_HOVER_GROUP_PATH:
            draft.hoverGroupHeadRecordId = action.payload;
            return draft;
        case action_constants_1.SET_HOVER_ROW_OF_ADD_RECORD:
            draft.hoverRowOfAddRecord = action.payload;
            return draft;
        default:
            return draft;
    }
}, exports.gridViewDragStateDefault);
//# sourceMappingURL=grid_view_drag.js.map